import { useState } from 'react';
import FormSelect from 'components/FormSelect/FormSelect';
import AgeAndGender from 'templates/IncomeAndExpendituresPageData/Templates/AgeAndGender'

interface Props {
    PageData?: any;
    Model?: any;
    IncomeAndExpenditureFormModel: any
    setIncomeAndExpenditureFormModel?: any;
    onChangeHouseHoldSituation: Function;
    isSubmitting?: boolean;
}

const AboutYouForm = (props: Props) => {
    const { Model, PageData, IncomeAndExpenditureFormModel, setIncomeAndExpenditureFormModel, onChangeHouseHoldSituation, isSubmitting } = props;
    const [showGenderAndAgeMultiple, setshowGenderAndAgeMultiple] = useState<boolean>(false);

    let newFormValues = { ...IncomeAndExpenditureFormModel.AboutYouFormModel };

    function changePeopleInHouse(e: string) {
        newFormValues["peopleInHouse"] = e;
        setIncomeAndExpenditureFormModel({ ...IncomeAndExpenditureFormModel, AboutYouFormModel: newFormValues });
        setAgeGenderFormValues();
        let numPeopleInHouse: number = parseInt(e);
        if (numPeopleInHouse > 1) {
            setshowGenderAndAgeMultiple(true);
        }
        else {
            setshowGenderAndAgeMultiple(false);
        }
    };

    function setAgeGenderFormValues() {
        newFormValues["AgeAndGender"] = [{
            "age": "",
            "gender": ""
        }];
        setIncomeAndExpenditureFormModel({ ...IncomeAndExpenditureFormModel, AboutYouFormModel: newFormValues });

        let numPeopleInHouse: number = parseInt(newFormValues.peopleInHouse);
        for (let i = 1; i < numPeopleInHouse; i++) {
            const obj = {
                "age": "",
                "gender": ""
            };
            newFormValues["AgeAndGender"].push(obj);
            setIncomeAndExpenditureFormModel({ ...IncomeAndExpenditureFormModel, AboutYouFormModel: newFormValues });
        }
    }

    return (
        <div className="IncomeAndExpenditure__formWrapper AboutYou">
            <form id="aboutYou" className="IncomeAndExpenditure__form AboutYou__form">
                <p className="IncomeAndExpenditure__formInfo">
                    {PageData?.FormHeaderNote}
                </p>
                <div className="AboutYou__formWrapper">
                    <div className="AboutYou__formGrid">
                        <div className="AboutYou__formColumn">
                            <div className="FormSelect__Wrapper">
                                <p className="FormSelect__Label">
                                    {PageData?.HouseHoldSituationLabel}
                                </p>
                                <div className="FormSelect__Row" >
                                    <FormSelect
                                        value={IncomeAndExpenditureFormModel.AboutYouFormModel.houseHoldSituation}
                                        options={[PageData?.HouseHoldSituationFirstOptionLabel, PageData?.HouseHoldSituationSecondOptionLabel, PageData?.HouseHoldSituationThirdOptionLabel, PageData?.HouseHoldSituationFourthOptionLabel]}
                                        onChange={(val) => onChangeHouseHoldSituation(val)}
                                        indicateError={(isSubmitting && !IncomeAndExpenditureFormModel.AboutYouFormModel.houseHoldSituation)}
                                    />
                                </div>
                            </div>
                            <div className="FormSelect__Wrapper">
                                <p className="FormSelect__Label">
                                    {PageData?.HowManyPeopleInHouseLabel}
                                </p>
                                <div className="FormSelect__Row">
                                    <FormSelect
                                        value={IncomeAndExpenditureFormModel.AboutYouFormModel.peopleInHouse}
                                        options={[PageData?.PeopleInHouseFirstOptionLabel, PageData?.PeopleInHouseSecondOptionLabel, PageData?.PeopleInHouseThirdOptionLabel, PageData?.PeopleInHouseFourthOptionLabel]}
                                        onChange={(val) => changePeopleInHouse(val)}
                                        indicateError={(isSubmitting && !IncomeAndExpenditureFormModel.AboutYouFormModel.peopleInHouse)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="AboutYou__dynamicInputsWrapper">
                            <div className="FormSelect__Wrapper">
                                <p id="genderAndAgeSingleLabel" className="FormSelect__Label" style={showGenderAndAgeMultiple ? { "display": "none" } : { "display": "block" }}>{PageData?.SelectYourGenderAndAgeLabel}</p>

                                <p id="genderAndAgeMultipleLabel" className="FormSelect__Label" style={showGenderAndAgeMultiple ? { "display": "block" } : { "display": "none" }}>{PageData?.SelectEachPersonGenderAndAgeLabel}</p>
                                
                                <div id="inputsWrapper" className="AboutYou__dynamicInputs">
                                    {(IncomeAndExpenditureFormModel.AboutYouFormModel.AgeAndGender) != null &&
                                        ((IncomeAndExpenditureFormModel.AboutYouFormModel.AgeAndGender)?.map((element: any, index: number) => (
                                            <AgeAndGender
                                                index={index}
                                                formValues={IncomeAndExpenditureFormModel}
                                                setFormValues={setIncomeAndExpenditureFormModel}
                                                isSubmitting={isSubmitting}
                                                {...props}
                                            />
                                        )))}

                                </div>
                            </div>
                        </div>
                        <p className={"AboutYou__formRequiredText " + ((isSubmitting) ? "error" : "")}>{PageData?.TheseAreRequiredFieldsText}</p>
                    </div>
                </div>
            </form>
        </div>
    );
};
export default AboutYouForm;